/* NAD+ Perfected buy box (hpn-nadp-buy-box). Scoped to [data-nadp-buy]. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__nadpBuyReady) return;
    root.__nadpBuyReady = true;

    var offers = Array.prototype.slice.call(root.querySelectorAll('[data-offer]'));
    var strengthButtons = Array.prototype.slice.call(root.querySelectorAll('[data-strength-option]'));
    var subscribeInput = root.querySelector('[data-subscribe]');
    var subscribeBox = root.querySelector('[data-subscribe-box]');
    var cta = root.querySelector('[data-cta]');
    var errorEl = root.querySelector('[data-error]');
    var ctaLabel = cta ? cta.textContent : '';
    var tpl = {
      billedOtp: root.getAttribute('data-tpl-billed-otp') || '',
      billedSub: root.getAttribute('data-tpl-billed-sub') || '',
      perServing: root.getAttribute('data-tpl-per-serving') || '',
      save: root.getAttribute('data-tpl-save') || '',
      subLabel: root.getAttribute('data-tpl-sub-label') || ''
    };
    var compareMode = root.getAttribute('data-compare-mode') || 'total';
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';

    /* ---------- Money ---------- */
    function money(cents, trimZeros) {
      var value = (Math.round(Number(cents) || 0) / 100).toFixed(2);
      if (trimZeros && /\.00$/.test(value)) value = value.slice(0, -3);
      var parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var amount = parts.join('.');
      return moneyFormat.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
    }

    function fill(template, values) {
      return String(template).replace(/\[(\w+)\]/g, function (m, key) {
        return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : m;
      });
    }

    /* ---------- State ---------- */
    function strength() {
      return root.getAttribute('data-strength') || 'es';
    }

    function wantsSubscribe() {
      return !!(subscribeInput && subscribeInput.checked);
    }

    function selectedOffer() {
      for (var i = 0; i < offers.length; i++) {
        if (offers[i].classList.contains('is-selected')) return offers[i];
      }
      return offers[0] || null;
    }

    function num(offer, attr) {
      return Number(offer.getAttribute(attr) || 0);
    }

    /* What this offer costs right now for the selected strength */
    function quote(offer) {
      var key = strength();
      var otp = num(offer, 'data-' + key + '-otp');
      var subRaw = offer.getAttribute('data-' + key + '-sub');
      var canSub = offer.getAttribute('data-allow-sub') === 'true' && subRaw !== null && subRaw !== '';
      var sub = canSub ? Number(subRaw) : 0;
      var useSub = canSub && wantsSubscribe();
      var bottles = Math.max(1, num(offer, 'data-bottles'));
      var total = useSub ? sub : otp;
      var msrp = num(offer, 'data-' + key + '-msrp');
      var save = msrp > 0 && total > 0 ? Math.round(((msrp - total) / msrp) * 100) : 0;
      return {
        key: key,
        otp: otp,
        sub: sub,
        canSub: canSub,
        useSub: useSub,
        total: total,
        bottles: bottles,
        perBottle: Math.round(total / bottles),
        subPerBottle: canSub ? Math.round(sub / bottles) : 0,
        perServing: Math.round(total / Math.max(1, num(offer, 'data-servings'))),
        msrp: msrp,
        save: save,
        extraPct: canSub && otp > 0 ? Math.round(((otp - sub) / otp) * 100) : 0
      };
    }

    /* ---------- Render ---------- */
    function renderOffer(offer) {
      var q = quote(offer);
      var priceEl = offer.querySelector('[data-price]');
      var compareEl = offer.querySelector('[data-compare]');
      var saveEl = offer.querySelector('[data-save]');
      var billedEl = offer.querySelector('[data-billed]');
      var perEl = offer.querySelector('[data-per-serving]');

      if (priceEl) priceEl.textContent = money(q.perBottle, true);

      var showSave = q.save >= 1;
      if (saveEl) {
        saveEl.textContent = showSave ? fill(tpl.save, { percent: q.save }) : '';
        saveEl.hidden = !showSave || !tpl.save;
      }
      if (compareEl) {
        var compareCents = compareMode === 'per_bottle' ? Math.round(q.msrp / q.bottles) : q.msrp;
        compareEl.textContent = showSave ? money(compareCents, true) : '';
        compareEl.hidden = !showSave;
      }
      if (billedEl) {
        var showBilled = offer.getAttribute('data-show-billed') === 'true';
        var days = offer.getAttribute('data-days') || '';
        billedEl.textContent = showBilled
          ? fill(q.useSub ? tpl.billedSub : tpl.billedOtp, { total: money(q.total, true), days: days })
          : '';
        billedEl.hidden = !showBilled;
      }
      if (perEl) {
        var showPer = offer.getAttribute('data-show-per-serving') === 'true' && tpl.perServing;
        perEl.textContent = showPer ? fill(tpl.perServing, { price: money(q.perServing, false) }) : '';
        perEl.hidden = !showPer;
      }
    }

    function renderSubscribe() {
      if (!subscribeBox) return;
      var offer = selectedOffer();
      var q = offer ? quote(offer) : null;
      var labelEl = subscribeBox.querySelector('[data-subscribe-label]');
      var priceEl = subscribeBox.querySelector('[data-subscribe-price]');
      var subText = subscribeBox.querySelector('[data-subscribe-sub]');
      var naText = subscribeBox.querySelector('[data-subscribe-na]');
      var available = q && q.canSub;

      subscribeBox.classList.toggle('is-unavailable', !available);
      if (subscribeInput) subscribeInput.disabled = !available;
      if (labelEl) labelEl.textContent = fill(tpl.subLabel, { percent: available ? q.extraPct : 10 });
      if (priceEl) {
        priceEl.textContent = available ? '(' + money(q.subPerBottle, false) + (root.getAttribute('data-suffix') || '') + ')' : '';
      }
      if (subText) subText.hidden = !available;
      if (naText) naText.hidden = !!available;
    }

    function renderAll() {
      offers.forEach(renderOffer);
      renderSubscribe();
      filterGallery();
      clearError();
    }

    /* ---------- Offer selection ---------- */
    function selectOffer(offer) {
      offers.forEach(function (o) {
        var on = o === offer;
        o.classList.toggle('is-selected', on);
        var radio = o.querySelector('[data-offer-radio]');
        if (radio) radio.checked = on;
      });
      renderAll();
    }

    offers.forEach(function (offer) {
      var radio = offer.querySelector('[data-offer-radio]');
      if (radio) {
        radio.addEventListener('change', function () {
          if (radio.checked) selectOffer(offer);
        });
      }
    });

    if (subscribeInput) {
      subscribeInput.addEventListener('change', renderAll);
    }

    /* ---------- Strength ---------- */
    strengthButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-strength-option');
        root.setAttribute('data-strength', key);
        strengthButtons.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        root.querySelectorAll('[data-includes]').forEach(function (list) {
          list.hidden = list.getAttribute('data-includes') !== key;
        });
        var name = root.getAttribute('data-name-' + key) || '';
        if (name) {
          root.querySelectorAll('[data-strength-name]').forEach(function (el) {
            el.textContent = name;
          });
        }
        renderAll();
      });
    });

    /* ---------- Gallery ---------- */
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var stage = root.querySelector('.hpn-nadp-buy__stage');
    var current = 0;

    function visibleIndexes() {
      var key = strength();
      var list = [];
      slides.forEach(function (s, i) {
        var k = s.getAttribute('data-strength');
        if (k === 'all' || k === key) list.push(i);
      });
      return list.length ? list : slides.map(function (_, i) { return i; });
    }

    function show(index) {
      var list = visibleIndexes();
      if (!list.length) return;
      if (list.indexOf(index) === -1) index = list[0];
      current = index;
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === index);
      });
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
        t.hidden = list.indexOf(i) === -1;
      });
      var activeThumb = thumbs[index];
      var strip = root.querySelector('[data-thumbs]');
      if (activeThumb && strip && strip.scrollWidth > strip.clientWidth) {
        strip.scrollTo({ left: activeThumb.offsetLeft - strip.clientWidth / 2 + activeThumb.clientWidth / 2, behavior: 'smooth' });
      }
    }

    function step(dir) {
      var list = visibleIndexes();
      var pos = list.indexOf(current);
      show(list[(pos + dir + list.length) % list.length]);
    }

    function filterGallery() {
      show(current);
    }

    var prev = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
    });

    if (stage) {
      var startX = null;
      stage.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
        startX = null;
      });
    }

    /* ---------- Cart ---------- */
    function clearError() {
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }

    function post(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
        body: JSON.stringify(body || {})
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok) throw new Error((data && (data.description || data.message)) || 'Something went wrong. Please try again.');
          return data;
        });
      });
    }

    function parseGifts(raw) {
      return String(raw || '').split(',').map(function (part) {
        var bits = part.trim().split(':');
        var id = Number(bits[0]);
        if (!id) return null;
        return { id: id, quantity: Math.max(1, Number(bits[1]) || 1) };
      }).filter(Boolean);
    }

    function fetchCart() {
      return fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      }).then(function (res) { return res.json(); });
    }

    /* The free gift app (Bogos) adds the gift items to the cart on its own right
       after our add. Wait for them to land (and settle) before going to checkout,
       up to a few seconds, so the eBooks are in the order. */
    function waitForAppGifts(addedCount) {
      return new Promise(function (resolve) {
        var started = Date.now();
        var maxWait = 4000;
        var settle = 600;
        var lastCount = -1;
        var lastChange = Date.now();

        function check() {
          fetchCart().then(function (cart) {
            var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
            if (count !== lastCount) {
              lastCount = count;
              lastChange = Date.now();
            }
            var giftsArrived = count > addedCount;
            var now = Date.now();
            if ((giftsArrived && now - lastChange >= settle) || now - started >= maxWait) {
              resolve();
              return;
            }
            window.setTimeout(check, 250);
          }).catch(resolve);
        }

        window.setTimeout(check, 250);
      });
    }

    function checkoutUrl(code) {
      var url = new URL(root.getAttribute('data-checkout-path') || '/checkout', window.location.origin);
      new URLSearchParams(window.location.search).forEach(function (value, key) {
        if (key === 'view' || key === 'preview_theme_id' || key === 'discount') return;
        url.searchParams.set(key, value);
      });
      if (code) url.searchParams.set('discount', code);
      return url.pathname + url.search;
    }

    if (cta) {
      cta.addEventListener('click', function () {
        var offer = selectedOffer();
        if (!offer || cta.disabled) return;
        clearError();

        var q = quote(offer);
        var key = q.key;
        var variantId = Number(offer.getAttribute('data-' + key + '-variant'));
        var planId = Number(offer.getAttribute('data-' + key + '-plan'));
        var code = (offer.getAttribute('data-' + key + '-code') || '').trim();

        if (!variantId || offer.getAttribute('data-' + key + '-available') !== 'true') {
          showError('This option is not available right now. Please choose another.');
          return;
        }
        if (q.useSub && !planId) {
          showError('Subscribe & Save is not available for this option right now.');
          return;
        }

        var main = { id: variantId, quantity: 1 };
        if (q.useSub) main.selling_plan = planId;
        var items = [main].concat(parseGifts(offer.getAttribute('data-gifts')));

        cta.disabled = true;
        cta.textContent = root.getAttribute('data-loading-label') || ctaLabel;

        var ready = root.getAttribute('data-clear-cart') === 'true' ? post('/cart/clear.js') : Promise.resolve();
        var waitForGifts = offer.getAttribute('data-wait-gifts') === 'true';
        var addedCount = items.reduce(function (n, it) { return n + it.quantity; }, 0);

        ready
          .then(function () { return post('/cart/add.js', { items: items }); })
          .then(function () { return waitForGifts ? waitForAppGifts(addedCount) : null; })
          .then(function () { window.location.href = checkoutUrl(code); })
          .catch(function (err) {
            showError(err.message);
            cta.disabled = false;
            cta.textContent = ctaLabel;
          });
      });
    }

    renderAll();
    show(visibleIndexes()[0] || 0);
    fitShipping(root);
  }

  /* Keep the fast shipping line on one line: shrink the text a little when a
     long city name would overflow (down to 10px), and only then let it wrap. */
  function fitShipping(root) {
    var text = root.querySelector('.hpn-nadp-buy__shipping .location-message__text');
    if (!text) return;
    var busy = false;

    function fit() {
      if (busy) return;
      busy = true;
      text.style.fontSize = '';
      text.classList.remove('is-wrap');
      var size = parseFloat(getComputedStyle(text).fontSize) || 14;
      while (text.scrollWidth > text.clientWidth + 1 && size > 10) {
        size -= 0.5;
        text.style.fontSize = size + 'px';
      }
      if (text.scrollWidth > text.clientWidth + 1) text.classList.add('is-wrap');
      busy = false;
    }

    fit();
    // The city and date are filled in after load, so refit when they change
    if ('MutationObserver' in window) {
      new MutationObserver(function () { window.requestAnimationFrame(fit); })
        .observe(text, { childList: true, characterData: true, subtree: true });
    }
    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(fit, 150);
    });
  }

  function boot() {
    document.querySelectorAll('[data-nadp-buy]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-nadp-buy]');
    if (root) init(root);
  });
})();
